import { render, staticRenderFns } from "./EmailTesting.vue?vue&type=template&id=5536fb0d&scoped=true&"
import script from "./EmailTesting.vue?vue&type=script&lang=js&"
export * from "./EmailTesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536fb0d",
  null
  
)

export default component.exports